import React, { useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const B = '#0B3D6E', T = '#0F6E56';

const inp = {
  width: '100%', border: '1px solid #dde4ee', borderRadius: 9,
  padding: '11px 14px', fontSize: 13, background: '#f8fafc',
  color: '#0f172a', outline: 'none', fontFamily: 'inherit',
  boxSizing: 'border-box', transition: 'border-color 0.15s, box-shadow 0.15s',
};
const lbl = {
  display: 'block', fontSize: 11, fontWeight: 600, color: '#64748b',
  textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 5,
};

export default function Devis({ lang }) {
  const fr = lang === 'fr';
  const [step, setStep] = useState(1);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const [form, setForm] = useState({
    name: '', email: '', phone: '', company: '',
    type: '', employees: '', products: '', volume: '',
    message: '', urgent: false,
  });

  const types = fr
    ? ['Clinique privée', 'Hôpital public', 'Hôpital privé', 'Centre de santé', 'Cabinet médical', 'Pharmacie', 'Laboratoire', 'Autre']
    : ['Private clinic', 'Public hospital', 'Private hospital', 'Health center', 'Medical office', 'Pharmacy', 'Laboratory', 'Other'];

  const volumes = fr
    ? ['< 5 000 MAD/mois', '5 000 – 20 000 MAD/mois', '20 000 – 100 000 MAD/mois', '> 100 000 MAD/mois', 'Appel d\'offre ponctuel']
    : ['< 5,000 MAD/month', '5,000 – 20,000 MAD/month', '20,000 – 100,000 MAD/month', '> 100,000 MAD/month', 'One-time tender'];

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.company || !form.type) {
      toast.error(fr ? 'Veuillez remplir les champs obligatoires' : 'Please fill in required fields');
      return;
    }
    setSending(true);
    try {
      await api.post('/contact', {
        name: form.name, email: form.email, phone: form.phone,
        company: form.company,
        subject: fr ? `Demande de devis — ${form.type}` : `Quote request — ${form.type}`,
        message: `Type: ${form.type}\nVolume: ${form.volume}\nProduits: ${form.products}\nUrgent: ${form.urgent}\n\n${form.message}`,
      });
      setSent(true);
      toast.success(fr ? 'Devis demandé ! Réponse sous 24h.' : 'Quote requested! Reply within 24h.');
    } catch (e) {
      toast.error(fr ? 'Erreur lors de l\'envoi' : 'Send error');
    } finally { setSending(false); }
  };

  const devisSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: fr ? 'Demande de devis dispositifs médicaux Maroc' : 'Medical devices quote request Morocco',
    description: fr ? 'Demandez un devis gratuit pour vos dispositifs médicaux au Maroc. Réponse sous 24h.' : 'Request a free quote for your medical devices in Morocco. Reply within 24h.',
    url: 'https://lomedmedicare.com/devis',
    provider: { '@type': 'Organization', name: 'LOMED MEDICARE', url: 'https://lomedmedicare.com' },
  };

  if (sent) {
    return (
      <>
        <Helmet>
          <title>{fr ? 'Devis envoyé — LOMED MEDICARE' : 'Quote sent — LOMED MEDICARE'}</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <div style={{ maxWidth: 520, margin: '4rem auto', padding: '1rem', textAlign: 'center' }}>
          <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#E1F5EE', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem' }}>
            <svg viewBox="0 0 24 24" style={{ width: 36, height: 36, fill: 'none', stroke: T, strokeWidth: 2 }}><path d="M20 6L9 17l-5-5"/></svg>
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 10, color: B }}>
            {fr ? 'Demande envoyée !' : 'Request sent!'}
          </h1>
          <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.7, marginBottom: '2rem' }}>
            {fr ? 'Notre équipe commerciale vous contactera sous 24h avec un devis personnalisé.' : 'Our sales team will contact you within 24h with a personalized quote.'}
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/" style={{ background: B, color: '#fff', padding: '11px 22px', borderRadius: 9, fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>{fr ? 'Retour accueil' : 'Back to home'}</a>
            <a href="/catalogue" style={{ background: '#f1f5f9', color: '#475569', padding: '11px 22px', borderRadius: 9, fontSize: 13, fontWeight: 500, textDecoration: 'none' }}>{fr ? 'Voir le catalogue' : 'View catalogue'}</a>
          </div>
        </div>
      </>
    );
  }

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '1.5rem 1rem' }}>

      {/* ── SEO HEAD ── */}
      
        <title>{fr
          ? 'Demander un Devis Gratuit — Dispositifs Médicaux Maroc | LOMED MEDICARE'
          : 'Request a Free Quote — Medical Devices Morocco | LOMED MEDICARE'}</title>
        <meta name="description" content={fr
          ? "Demandez un devis gratuit et personnalisé pour vos dispositifs médicaux au Maroc. Réduction jusqu'à 30% sur les volumes. Réponse sous 24h ouvrées."
          : "Request a free personalized quote for your medical devices in Morocco. Up to 30% discount on volumes. Reply within 24 business hours."} />
        <meta name="keywords" content={fr
          ? 'devis dispositifs médicaux Maroc, devis matériel médical clinique, centrale achat médicale prix'
          : 'medical devices quote Morocco, clinic medical equipment quote, medical purchasing group price'} />
        <link rel="canonical" href="https://lomedmedicare.com/devis" />
        <meta property="og:title" content={fr ? 'Devis gratuit — Dispositifs médicaux Maroc' : 'Free quote — Medical devices Morocco'} />
        <meta property="og:description" content={fr ? "Réponse sous 24h. Réduction jusqu'à 30% sur les volumes." : 'Reply within 24h. Up to 30% discount on volumes.'} />
        <meta property="og:url" content="https://lomedmedicare.com/devis" />
        <script type="application/ld+json">{JSON.stringify(devisSchema)}</script>
      

      {/* Header */}
      <div style={{ marginBottom: '2rem' }}>
        <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', color: T, marginBottom: 5 }}>
          {fr ? 'Gratuit & sans engagement' : 'Free & no commitment'}
        </div>
        <h1 style={{ fontSize: 'clamp(20px,4vw,28px)', fontWeight: 700, marginBottom: 8, color: B }}>
          {fr ? 'Demander un devis personnalisé' : 'Request a personalized quote'}
        </h1>
        <p style={{ fontSize: 13.5, color: '#64748b', lineHeight: 1.7 }}>
          {fr ? "Remplissez ce formulaire et recevez une offre sur mesure sous 24h. Réduction jusqu'à 30% sur les volumes." : 'Fill in this form and receive a tailored offer within 24h. Up to 30% discount on volumes.'}
        </p>
      </div>

      {/* Progress steps */}
      <div style={{ display: 'flex', marginBottom: '2rem', borderRadius: 10, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
        {[
          { n: 1, label: fr ? 'Votre profil' : 'Your profile' },
          { n: 2, label: fr ? 'Vos besoins' : 'Your needs' },
          { n: 3, label: fr ? 'Confirmation' : 'Confirmation' },
        ].map((s, i) => (
          <div key={s.n} style={{
            flex: 1, padding: '10px 8px', textAlign: 'center', cursor: s.n < step ? 'pointer' : 'default',
            background: step === s.n ? B : step > s.n ? T : '#f8fafc',
            color: step >= s.n ? '#fff' : '#94a3b8',
            borderRight: i < 2 ? '1px solid #e2e8f0' : 'none',
            transition: 'background 0.2s',
          }} onClick={() => s.n < step && setStep(s.n)}>
            <div style={{ fontSize: 11, fontWeight: 700, marginBottom: 2 }}>{s.n}</div>
            <div style={{ fontSize: 10, opacity: 0.85 }}>{s.label}</div>
          </div>
        ))}
      </div>

      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 16, padding: '2rem', boxShadow: '0 4px 16px rgba(0,0,0,0.05)' }}>

        {step === 1 && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: '1.5rem' }}>{fr ? 'Votre établissement' : 'Your institution'}</h2>
            <div style={{ display: 'grid', gap: 16 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div><label style={lbl}>{fr ? 'Nom complet *' : 'Full name *'}</label><input style={inp} value={form.name} onChange={e => set('name', e.target.value)} placeholder="Dr. Mohamed El..."/></div>
                <div><label style={lbl}>{fr ? 'Email professionnel *' : 'Professional email *'}</label><input style={inp} type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="contact@clinique.ma"/></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div><label style={lbl}>{fr ? 'Téléphone' : 'Phone'}</label><input style={inp} value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="+212 6XX XX XX XX"/></div>
                <div><label style={lbl}>{fr ? "Nom de l'établissement *" : 'Institution name *'}</label><input style={inp} value={form.company} onChange={e => set('company', e.target.value)} placeholder="Clinique Al Wafaa..."/></div>
              </div>
              <div>
                <label style={lbl}>{fr ? "Type d'établissement *" : 'Institution type *'}</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 4 }}>
                  {types.map(t => (
                    <button key={t} onClick={() => set('type', t)} style={{ padding: '7px 14px', borderRadius: 8, fontSize: 12, cursor: 'pointer', border: `1.5px solid ${form.type === t ? B : '#dde4ee'}`, background: form.type === t ? '#EBF3FB' : '#fff', color: form.type === t ? B : '#64748b', fontWeight: form.type === t ? 600 : 400 }}>{t}</button>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
              <button onClick={() => { if (!form.name || !form.email || !form.company || !form.type) { toast.error(fr?'Remplissez les champs obligatoires':'Fill required fields'); return; } setStep(2); }} style={{ background: B, color: '#fff', border: 'none', padding: '11px 24px', borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                {fr ? 'Suivant →' : 'Next →'}
              </button>
            </div>
          </div>
        )}

        {step === 2 && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: '1.5rem' }}>{fr ? 'Vos besoins' : 'Your needs'}</h2>
            <div style={{ display: 'grid', gap: 16 }}>
              <div>
                <label style={lbl}>{fr ? "Volume d'achat estimé" : 'Estimated purchase volume'}</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 4 }}>
                  {volumes.map(v => (
                    <button key={v} onClick={() => set('volume', v)} style={{ padding: '7px 14px', borderRadius: 8, fontSize: 12, cursor: 'pointer', border: `1.5px solid ${form.volume === v ? T : '#dde4ee'}`, background: form.volume === v ? '#E1F5EE' : '#fff', color: form.volume === v ? T : '#64748b', fontWeight: form.volume === v ? 600 : 400 }}>{v}</button>
                  ))}
                </div>
              </div>
              <div><label style={lbl}>{fr ? 'Produits ou catégories souhaités' : 'Desired products or categories'}</label><textarea style={{ ...inp, minHeight: 90, resize: 'vertical' }} value={form.products} onChange={e => set('products', e.target.value)} placeholder={fr ? 'Ex: consommables chirurgie, médicaments anesthésie...' : 'E.g: surgery consumables, anesthesia medicines...'}/></div>
              <div><label style={lbl}>{fr ? 'Informations complémentaires' : 'Additional information'}</label><textarea style={{ ...inp, minHeight: 80, resize: 'vertical' }} value={form.message} onChange={e => set('message', e.target.value)} placeholder={fr ? "Appel d'offre, délais, conditions particulières..." : 'Tender, deadlines, special conditions...'}/></div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <input type="checkbox" id="urgent" checked={form.urgent} onChange={e => set('urgent', e.target.checked)} style={{ width: 16, height: 16, cursor: 'pointer', accentColor: B }}/>
                <label htmlFor="urgent" style={{ fontSize: 13, color: '#475569', cursor: 'pointer' }}>{fr ? '⚡ Besoin urgent — rappel sous 2h' : '⚡ Urgent need — callback within 2h'}</label>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1.5rem' }}>
              <button onClick={() => setStep(1)} style={{ background: '#f1f5f9', color: '#475569', border: 'none', padding: '11px 20px', borderRadius: 9, fontSize: 13, cursor: 'pointer' }}>← {fr ? 'Retour' : 'Back'}</button>
              <button onClick={() => setStep(3)} style={{ background: B, color: '#fff', border: 'none', padding: '11px 24px', borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>{fr ? 'Suivant →' : 'Next →'}</button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: '1.5rem' }}>{fr ? 'Confirmation' : 'Confirmation'}</h2>
            <div style={{ background: '#f8fafc', borderRadius: 12, padding: '1.25rem', marginBottom: '1.5rem', border: '0.5px solid #e2e8f0' }}>
              {[
                [fr?'Nom':'Name', form.name],
                ['Email', form.email],
                [fr?'Téléphone':'Phone', form.phone || '—'],
                [fr?'Établissement':'Institution', form.company],
                [fr?'Type':'Type', form.type],
                [fr?'Volume':'Volume', form.volume || '—'],
                [fr?'Urgent':'Urgent', form.urgent ? (fr?'Oui':'Yes') : (fr?'Non':'No')],
              ].map(([l, v]) => (
                <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: '0.5px solid #e2e8f0', fontSize: 13 }}>
                  <span style={{ color: '#94a3b8', fontWeight: 500 }}>{l}</span>
                  <span style={{ color: '#0f172a', fontWeight: 500, textAlign: 'right', maxWidth: '60%' }}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{ background: '#E1F5EE', borderRadius: 10, padding: '12px 14px', marginBottom: '1.5rem', fontSize: 13, color: T, display: 'flex', alignItems: 'center', gap: 8 }}>
              <svg viewBox="0 0 24 24" style={{ width: 16, height: 16, fill: 'none', stroke: T, strokeWidth: 2, flexShrink: 0 }}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              {fr ? 'Vos données sont confidentielles et utilisées uniquement pour établir votre devis.' : 'Your data is confidential and used only to prepare your quote.'}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <button onClick={() => setStep(2)} style={{ background: '#f1f5f9', color: '#475569', border: 'none', padding: '11px 20px', borderRadius: 9, fontSize: 13, cursor: 'pointer' }}>← {fr ? 'Modifier' : 'Edit'}</button>
              <button onClick={handleSubmit} disabled={sending} style={{ background: sending ? '#94a3b8' : T, color: '#fff', border: 'none', padding: '12px 28px', borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: sending ? 'not-allowed' : 'pointer' }}>
                {sending ? (fr ? 'Envoi...' : 'Sending...') : (fr ? '✓ Envoyer ma demande' : '✓ Send my request')}
              </button>
            </div>
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 10, marginTop: '1.5rem' }}>
        {[['⚡', fr?'Réponse sous 24h':'Reply within 24h'], ['💰', fr?'Devis gratuit':'Free quote'], ['🔒', fr?'Sans engagement':'No commitment'], ['📞', fr?'Accompagnement dédié':'Dedicated support']].map(([icon, label]) => (
          <div key={label} style={{ background: '#fff', border: '0.5px solid #e2e8f0', borderRadius: 10, padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10, fontSize: 12.5, color: '#475569', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
            <span style={{ fontSize: 18 }}>{icon}</span> {label}
          </div>
        ))}
      </div>
    </div>
  );
}

